import React from "react";

type Props = {
  href: string;
  text: string;
};

const LineLoginButton: React.FC<Props> = (props) => {
  const { href, text } = props;
  return (
    <a
      href={href}
      className="link-hover-none hover:bg-[#00B900] before:mr-[10px] left-icon icon-line-white !bg-[#00B900] h-[50px] font-raleway rounded-default block flex items-center justify-center w-full text-white text-sm"
    >
      {text}
    </a>
  );
};

export default LineLoginButton;
